<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <div class="row my-4 legenda">
      <div class="d-flex align-items-center justify-content-md-center col-12 col-md-4 my-1 my-md-0">
        <div class="mx-3 fw-500 btn btn-outline-primary active btn-sm">SF</div>
        <span class="f-14"> Série de fábrica </span>
      </div>
      <div class="d-flex align-items-center justify-content-md-center col-12 col-md-4 my-1 my-md-0">
        <div class="mx-3 fw-500 btn btn-outline-primary active btn-sm">ND</div>
        <span class="f-14"> Não disponível de fábrica </span>
      </div>
      <div class="d-flex align-items-center justify-content-md-center col-12 col-md-4 my-1 my-md-0">
        <div class="mx-3 fw-500 btn btn-outline-primary active btn-sm">OP</div>
        <span class="f-14"> Opcional de fábrica </span>
      </div>
    </div>

    <ng-container *ngFor="let v of consulta?.lista; let i = index">

      <h2 class="subtitle">VEÍCULO {{i + 1}}</h2>

      <div class="row">
        <div class="col-12 col-md-8 col-lg-5 p-2 veiculo-molicar">
          <div class="text-secondary">Veículo:</div>
          <div>{{v?.modelo || 'NÃO INFORMADO'}} {{v?.versaoOriginal}}</div>
        </div>
        <div class="col-12 col-md-4 col-lg-2 p-2 veiculo-molicar">
          <div class="text-secondary">Ano Modelo:</div>
          <div>{{v?.anoModelo || 'NÃO INFORMADO'}}</div>
        </div>
        <div class="col-12 col-md-8 col-lg-3 p-2 veiculo-molicar">
          <div class="text-secondary">Marca:</div>
          <div>{{v?.marca || 'NÃO INFORMADO'}}</div>
        </div>
        <div class="col-12 col-md-4 col-lg-2 p-2 veiculo-molicar">
          <div class="text-secondary">Valor atual:</div>
          <div>{{v?.valorAtual ? (v?.valorAtual | currency:'R$') : 'NÃO INFORMADO'}}</div>
        </div>
      </div>


      <ul class="card-list-striped card-list-striped-3 card-list-preco-molicar">
        <li><span class="text-secondary">Vidros/Travas Elétricas</span>
          <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.vidroTravaEletrica=='Série de fábrica', 'disabled': v?.vidroTravaEletrica!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.vidroTravaEletrica=='Não disponível de fábrica', 'disabled': v?.vidroTravaEletrica!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.vidroTravaEletrica=='Opcional de fábrica', 'disabled': v?.vidroTravaEletrica!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Forrações em couro</span>
          <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.bancoCouro=='Série de fábrica', 'disabled': v?.bancoCouro!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.bancoCouro=='Não disponível de fábrica', 'disabled': v?.bancoCouro!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.bancoCouro=='Opcional de fábrica', 'disabled': v?.bancoCouro!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Freios ABS</span>
          <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.freioAbs=='Série de fábrica', 'disabled': v?.freioAbs!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.freioAbs=='Não disponível de fábrica', 'disabled': v?.freioAbs!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.freioAbs=='Opcional de fábrica', 'disabled': v?.freioAbs!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Direção Assistida</span>
          <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.direcaoAssistida=='Série de fábrica', 'disabled': v?.direcaoAssistida!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.direcaoAssistida=='Não disponível de fábrica', 'disabled': v?.direcaoAssistida!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.direcaoAssistida=='Opcional de fábrica', 'disabled': v?.direcaoAssistida!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Teto solar</span>
          <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.tetoSolar=='Série de fábrica', 'disabled': v?.tetoSolar!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.tetoSolar=='Não disponível de fábrica','disabled': v?.tetoSolar!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.tetoSolar=='Opcional de fábrica','disabled': v?.tetoSolar!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Air bag</span>
          <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.airBag=='Série de fábrica', 'disabled': v?.airBag!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.airBag=='Não disponível de fábrica', 'disabled': v?.airBag!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.airBag=='Opcional de fábrica', 'disabled': v?.airBag!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Ar Condicionado</span> <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.arCondicionado=='Série de fábrica', 'disabled': v?.arCondicionado!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.arCondicionado=='Não disponível de fábrica', 'disabled': v?.arCondicionado!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.arCondicionado=='Opcional de fábrica', 'disabled': v?.arCondicionado!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Kit multimídia</span> <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.kitMultimidia=='Série de fábrica', 'disabled': v?.kitMultimidia!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.kitMultimidia=='Não disponível de fábrica', 'disabled': v?.kitMultimidia!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.kitMultimidia=='Opcional de fábrica','disabled': v?.kitMultimidia!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Rodas de liga leve</span> <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.rodaLigaLeve=='Série de fábrica', 'disabled': v?.rodaLigaLeve!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.rodaLigaLeve=='Não disponível de fábrica', 'disabled': v?.rodaLigaLeve!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.rodaLigaLeve=='Opcional de fábrica', 'disabled': v?.rodaLigaLeve!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Câmbio Automático</span> <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.cambioAutomatico=='Série de fábrica', 'disabled': v?.cambioAutomatico!='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary disabled btn-xs fw-500"
              [ngClass]="{'active': v?.cambioAutomatico=='Não disponível de fábrica', 'disabled': v?.cambioAutomatico!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary btn-xs fw-500"
              [ngClass]="{'active': v?.cambioAutomatico=='Opcional de fábrica', 'disabled': v?.cambioAutomatico!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li><span class="text-secondary">Kit GNV</span> <span class="d-flex justify-content-end">
            <div class="mx-1 btn btn-outline-primary btn-xs fw-500"
              [ngClass]="{'active': v?.Op11=='Série de fábrica', 'disabled': v?.Op11=='Série de fábrica'}">SF</div>
            <div class="mx-1 btn btn-outline-primary btn-xs fw-500"
              [ngClass]="{'active': v?.Op11=='Não disponível de fábrica', 'disabled': v?.Op11!='Não disponível de fábrica'}">ND</div>
            <div class="mx-1 btn btn-outline-primary btn-xs fw-500"
              [ngClass]="{'active': v?.Op11=='Opcional de fábrica', 'disabled': v?.Op11!='Opcional de fábrica'}">OP</div>
          </span></li>
        <li class="invisible"></li>
      </ul>

    </ng-container>

  </ng-container>

</app-card-consulta>
